<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert type="warning" show-icon>
            委托招聘须知
            <template slot="desc">
              1、委托招聘仅为拥有人力资源服务的机构可以进行委托发布，普通企业用户无法使用。
              <br>
              2、委托职位仍为机构的职位，委托单位没有操作权限。
              <br>
              3、委托职位的求职信息发送至机构后台。
            </template>
          </Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索" @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '添加职位')" class="search-btn">添加职位</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
            <Button type="success" class="search-btn" @click="handlerUp">批量启用</Button>

          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table size="small" ref="table_job" border :columns="columns_job" :data="tableData_job" height="500"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Alert banner closable>请务必确认委托单为已在库单位，委托发布的职位会同步至企业后台，企业账号内也可修改。</Alert>
            <Form ref="formValidate_job" :model="formValidate_job" :rules="ruleValidate" :label-width="100">
              <FormItem
                label="委托单位"
                prop="broker_company"
              >
               <el-select
                 :disabled="formValidate_job.Id !== 0"
                 style="width: 100%"
                  v-model="formValidate_job.bcid"
                  filterable
                  remote
                 allow-create
                  reserve-keyword
                  placeholder="请输入委托单位"
                  :remote-method="remoteMethod"
                  :loading="loading">
                  <el-option
                    v-for="item in companyoptions"
                    :key="item.Id"
                    :label="item.Cname"
                    :value="parseInt(item.Id)">
                  </el-option>
                </el-select>
              </FormItem>
           <FormItem
                label="职位名称"
                prop="Jobname"
              >
                <Input
                  v-model="formValidate_job.Jobname"
                  placeholder="请输入"
                ></Input>

              </FormItem>
<!--              <FormItem-->
<!--                label="职位简称"-->
<!--                prop="Jabbreviation"-->
<!--              >-->
<!--                <Input-->
<!--                  v-model="formValidate_job.Jabbreviation"-->
<!--                  placeholder="请输入"-->
<!--                ></Input>-->
<!--              </FormItem>-->
              <FormItem
                label="职位类别"
                prop="Jabbreviation"
              >
                <el-cascader
                  v-model="formValidate_job.Jabbreviation"
                  placeholder="请选择"
                  :options="JabbreviationList"
                  filterable
                  clearable></el-cascader>
              </FormItem>

              <FormItem
                label="职位描述"
                prop="Jdescribe"
              >
                <Input
                  type="textarea"
                  v-model="formValidate_job.Jdescribe"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <!--<FormItem-->
              <!--  label="优先人群"-->
              <!--  prop="Jsuit"-->
              <!--  <el-checkbox-group v-model="formValidate_job.Jsuit" size="medium">-->
              <!--    <el-checkbox-button v-for="suit in suits" :label="suit" :key="suit">{{suit}}</el-checkbox-button>-->
              <!--  </el-checkbox-group>-->
              <!--</FormItem>-->
              <FormItem
                label="招聘人数"
                prop="Jnum"
              >

                <Input
                  v-model="formValidate_job.Jnum"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="工作经验" prop="Jexperience">
                <el-select
                  v-model="formValidate_job.Jexperience"
                  filterable

                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJexperienceList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="学历" prop="Jeducation">
                <el-select
                  v-model="formValidate_job.Jeducation"
                  filterable

                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJeducationList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="薪资" prop="Jsalary_type">
                <el-select
                  v-model="formValidate_job.Jsalary_type"
                  filterable
                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJsalarytypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
                <el-checkbox v-model="formValidate_job.Jsalary_number_type" true-label=1 false-label=0 label="区间金额" border></el-checkbox>
              </FormItem>
              <FormItem
                v-if = "formValidate_job.Jsalary_type!=0"
                label="数额"
                prop="Jsalary_number"
              >
                <InputNumber
                  :style="formValidate_job.Jsalary_number_type == 1?'':'width: 50%'"
                  :max="1000000"
                  :min="0"
                  @input="changnumber"
                  :step="0.1"
                  v-model="formValidate_job.Jsalary_number"
                  :formatter="value => (`$ ${value}`) .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
                {{ formValidate_job.Jsalary_number_type == 1? '-' : '' }}
                <InputNumber
                  v-if="formValidate_job.Jsalary_number_type == 1"
                  @input="changnumber"
                  :max="1000000"
                  :min="0"
                  :step="0.1"
                  :formatter="value => (`$ ${value}`) .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  v-model="formValidate_job.Jsalary_number_end"/>{{getsalarytype(formValidate_job.Jsalary_type)}}

              </FormItem>
              <!--<FormItem label="薪资" prop="Jsalary">-->
              <!--  <el-select-->
              <!--    v-model="formValidate_job.Jsalary"-->
              <!--    filterable-->
              <!--    default-first-option-->
              <!--    placeholder="请选择">-->
              <!--    <el-option-->
              <!--      v-for="item in jobJsalaryList"-->
              <!--      :key="item.value"-->
              <!--      :label="item.meaning"-->
              <!--      :value="item.value">-->
              <!--    </el-option>-->
              <!--  </el-select>-->
              <!--  -->
              <!--</FormItem>-->
              <FormItem label="性别" prop="Jsex">
                <el-select
                  v-model="formValidate_job.Jsex"
                  filterable

                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJsexList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="年龄" prop="Jage">
                <InputNumber
                  :max="99"
                  :min="0"
                  v-model="formValidate_job.Jage_s"/> 至
                <InputNumber
                  :max="99"
                  :min="0"
                  v-model="formValidate_job.Jage_e"/>
                <!--<el-select-->
                <!--  v-model="formValidate_job.Jage"-->
                <!--  filterable-->

                <!--  default-first-option-->
                <!--  placeholder="请选择">-->
                <!--  <el-option-->
                <!--    v-for="item in jobJageList"-->
                <!--    :key="item.value"-->
                <!--    :label="item.meaning"-->
                <!--    :value="item.value">-->
                <!--  </el-option>-->
                <!--</el-select>-->
              </FormItem>
              <FormItem label="婚姻" prop="Jmarriage">
                <el-select
                  v-model="formValidate_job.Jmarriage"
                  filterable

                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJmarriageList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="其他要求"
                prop="Jrequirement"
              >
                <Input
                  type="textarea"
                  v-model="formValidate_job.Jrequirement"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem
                label="工作地址"
                prop="Jaddress"
              >
                <Input
                  v-model="formValidate_job.Jaddress"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="开始时间" prop="Jstime">
                <DatePicker  type="datetime" editable v-model="formValidate_job.Jstime" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end" placeholder="请选择开始时间" ></DatePicker>
              </FormItem>

              <FormItem label="结束时间" prop="Jetime">
                <DatePicker  type="datetime" editable v-model="formValidate_job.Jetime" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end" placeholder="请选择结束时间" ></DatePicker>
              </FormItem>

              <FormItem label="类型" prop="Jtype">
                <el-select
                  v-model="formValidate_job.Jtype"
                  filterable

                  default-first-option
                  placeholder="请选择">
                  <el-option
                    v-for="item in jobJtypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="联系人"
                prop="Jlinkman"
              >
                <Input
                  v-model="formValidate_job.Jlinkman"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem
                label="联系电话"
                prop="Jphone"
              >
                <Input
                  v-model="formValidate_job.Jphone"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit_job('formValidate_job')"
                >提交
                </Button>

              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

  import {
    getjoblist,
    getjobstypeList,
    operationjob,
    changeJob
  } from '@/api/apply/apply.js'

  import {getsysparameterList} from '@/api/system/sys_parameter'
import {
  getCompanylist
} from '@/api/scinfo/scinfo.js'
  // import {Notification} from 'element-ui';

  let moment = require('moment')
  export default {

    data () {
      return {
        companyoptions: [],
        loading: false,
        jobJsalarytypeList:[],
        spinShow: false,
        fullscreenLoading: false,
        jobstateList: [],
        jobJexperienceList: [],
        jobJeducationList: [],
        jobJsalaryList: [],
        jobJsexList: [],
        jobJageList: [],
        jobJstateList: [],
        jobJtypeList: [],
        jobJmarriageList: [],
        formValidate_job: {
        Jsuit: []
        },
        JabbreviationList: [],
        formValidate: {
          Id: 0,
          Mid: 0,
          Jname: '',
          Jstime: '',
          Jtype: 0,
          Jetime: '',
          Jstate: 0
        },
        suits: ['退役军人', '退役军人配偶', '退役军人子女'],
        searchVal: '',
        tableData_job: [],
        modalMap: {
          modalVisible: false,
          modalTitle: '新建'
        },
        tableSelectIdList: [],
        editModalData: '',
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数
        pageSize: 15, // 每页条数
        ruleValidate: {
          // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
         Jobname: [
            {
              required: true,
              message: '名称不能为空',
              trigger: 'blur'
            }
          ],
          Jabbreviation: [
            {
              type: 'array',
              required: true,
              message: '请选择工种',
              trigger: 'blur'
            }
          ],
          Jnum: [
            {
              required: true,
              message: '不能为空',
              trigger: 'blur'
            }
          ],
          Jexperience: [
            {
              required: true,
              message: '请选择工作经验',
              trigger: 'change'
            }
          ],
          Jeducation: [
            {
              required: true,
              message: '请选择学历',
              trigger: 'change'
            }
          ],
          Jsalary: [
            {
              required: true,
              message: '请选择薪资',
              trigger: 'change'
            }
          ],
          Jsex: [
            {
              required: true,
              message: '请选择性别要求',
              trigger: 'change'
            }
          ],

          Jmarriage: [
            {
              required: true,
              message: '请选择婚姻要求',
              trigger: 'change'
            }
          ],
          Jaddress: [
            {
              required: true,
              message: '工作地址不能为空',
              trigger: 'blur'
            }
          ],
          Jstime: [
            {
              required: true,
              type: 'date',
              message: '请选择开始时间',
              trigger: 'change'
            }
          ],
          // Jetime: [
          //   {
          //     required: true,
          //     type:"date",
          //     message: "请选择结束时间",
          //     trigger: "change"
          //   }
          // ],
          Jtype: [
            {
              required: true,
              message: '请选择职位类型',
              trigger: 'change'
            }
          ],
          Jphone: [
            {
              required: true,
              message: '联系电话不能为空',
              trigger: 'blur'
            }
          ],
          Jlinkman: [
            {
              required: true,
              message: '联系人不能为空',
              trigger: 'blur'
            }
          ]

        },
        columns_job: [
          {
            type: 'selection',
            key: 'id',
            width: 60,
            fixed: 'left',
            align: 'center'
          },
          {
            title: '单位名称',
            key: 'broker_company',
            align: 'center',
            fixed: 'left',
            tooltip: true,
            sortable: true,
            width: 220,
            render: (h, params) => {
              if (params.row.broker_cid == -1 || !params.row.broker_cid){
                return h('div',[
                  h('Badge',{props: {dot: true}},[
                    h('div', params.row.broker_company)
                  ])
                ])
              }else{
                return h('div',{}, params.row.broker_company)
              }

            }
            },
          {
            title: '职位名称',
            key: 'Jobname',
            align: 'center',
            fixed: 'left',
            tooltip: true,
            sortable: true,
            width: 180
          },
          {
            title: '人数',
            key: 'Jnum',
            width: 80,
            tooltip: true,
            align: 'center',
            sortable: true
          },
          {
            title: '性别',
            key: 'Jsex_CN',
            align: 'center',
            sortable: true,
            tooltip: true,
            width: 80
          },
          {
            title: '学历',
            key: 'Jeducation_CN',
            align: 'center',
            sortable: true,
            tooltip: true,
            width: 120
          },
          {
            title: '工作经验',
            key: 'Jexperience_CN',
            align: 'center',
            sortable: true,
            tooltip: true,
            width: 150
          },

          {
            title: '薪资',
            key: 'Jsalary_CN',
            align: 'center',
            tooltip: true,
            sortable: true,
            width: 150
          },
          {
                                title: '岗位描述',
                                key: 'Jdescribe',
                                align: 'center',
                                tooltip: true,
                                sortable: true,
            width: 150
                            },
          {
            title: '开始时间',
            key: 'Jstime',
            align: 'center',
            tooltip: true,
            sortable: true,
            width: 180
          },
          {
            title: '结束时间',
            key: 'Jetime',
            align: 'center',
            tooltip: true,
            sortable: true,
            width: 180
          },

          {
            title: '状态',
            key: 'handle',
            width: 100,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Tag', {props: {color: params.row.Jstate_col}}, params.row.Jstate_CN)
              ])
            }
          },
          {
            title: '操作',
            key: 'handle',
            fixed: 'right',
            width: 180,
            align: 'center',
            render: (h, params) => {
              if (params.row.Jstate == 1) {
                return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.changstate(params.row)
                        }
                      }
                    },
                    '暂停'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          this.delData(params)
                        }
                      }
                    },
                    '删除'
                  )
                ])
              } else if (params.row.Jstate == 0 || params.row.Jstate == 9) {
                return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          this.delData(params)
                        }
                      }
                    },
                    '删除'
                  )
                ])
              } else {
                return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.editModal(params.row, 'put', '修改')
                        }
                      }
                    },
                    '编辑'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'success',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.changstate(params.row)
                        }
                      }
                    },
                    '启用'
                  ),

                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          this.delData(params)
                        }
                      }
                    },
                    '删除'
                  )
                ])
              }
            }
          }
        ]
      }
    },
    methods: {
      remoteMethod (query) {
        if (query !== '') {
          this.loading = true
          setTimeout(() => {
            this.loading = false
            getCompanylist(1, 20, query, '').then(res => {
              if (res.data.code === 0) {
                this.companyoptions = res.data.data
              }
            })
          }, 200)
        } else {
          this.companyoptions = []
        }
      },
      getjoblist (key, value) {
        this.spinShow = true

        getjoblist(this.pageNum, this.pageSize, key, value, 2).then(res => {
          if (res.data.code === 0) {
            this.tableData_job = res.data.data
            this.pageTotal = res.data.count
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },
      handleSubmit_job (value) {
        this.$refs[value].validate((valid) => {
          if (valid) {
            this.formValidate_job.Jstime = moment(this.formValidate_job.Jstime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate_job.Jetime = moment(this.formValidate_job.Jetime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss');
            if (this.formValidate_job.Jsuit.length > 0) {
              this.formValidate_job.Jrecommend = '3|1'
            }

            setTimeout(() => {
              if (this.editModalData == 'post' && this.formValidate_job.Jsuit.length > 0) {
                this.formValidate_job.Jrecommend = '0010'
              }
              operationjob(this.formValidate_job, this.editModalData).then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  if (this.searchVal) {
                    this.getjoblist(this.searchVal)
                  } else {
                    this.getjoblist()
                  }
                  this.modalMap.modalVisible = false
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
            }, 1000)
            // this.$Message.success('Success!');
          } else {
            this.$Message.error('请输入完整信息')
          }
        })
      },

      // table 选中的ID
      handleSelectChange (val) {
        let SelectIdList = []
        val.forEach(item => {
          SelectIdList.push(item.Id)
        })

        this.tableSelectIdList = SelectIdList
      },

      closeModal () {
        this.dialog.show = false
      },
      getjobspapamsList () {
        getsysparameterList('job_info', 'Jexperience').then(res => {
          if (res.data.code === 0) {
            this.jobJexperienceList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('job_info', 'Jeducation').then(res => {
          if (res.data.code === 0) {
            this.jobJeducationList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('job_info', 'Jsalary').then(res => {
          if (res.data.code === 0) {
            this.jobJsalaryList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('job_info', 'Jsalary_type').then(res => {
          if (res.data.code === 0) {
            this.jobJsalarytypeList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('job_info', 'Jsex').then(res => {
          if (res.data.code === 0) {
            this.jobJsexList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('job_info', 'Jage').then(res => {
          if (res.data.code === 0) {
            this.jobJageList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('job_info', 'Jmarriage').then(res => {
          if (res.data.code === 0) {
            this.jobJmarriageList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
        getsysparameterList('job_info', 'Jtype').then(res => {
          if (res.data.code === 0) {
            this.jobJtypeList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      getjobstypeList (value, level) {
        getjobstypeList(value, level).then(res => {
          if (res.data.code === 0) {
            this.JabbreviationList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },
      changnumber(){
        if (this.formValidate_job.Jsalary_number_end < this.formValidate_job.Jsalary_number){
          this.formValidate_job.Jsalary_number_end = this.formValidate_job.Jsalary_number
        }
      },
      handleSearch () {
        this.getjoblist(this.searchVal)
      },
      // 点击节点
      // 翻页
      changePage (value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getjoblist(this.searchVal)
        } else {
          this.getjoblist()
        }
      },
      // 切换分页
      handlePageSize (value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getjoblist(this.searchVal)
        } else {
          this.getjoblist()
        }
      },
      searchinput () {
        if (this.searchVal) {
          this.getjoblist(this.searchVal)
        } else {
          this.getjoblist()
        }
      },
      changstate (paramsRow) {
        let params = {
        "Id": paramsRow.Id,
        "Jstate": paramsRow.Jstate
        }
        setTimeout(() => {
          changeJob(params, 'PUT').then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              if (this.searchVal) {
                this.getjoblist(this.searchVal)
              } else {
                this.getjoblist()
              }
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }, 1000)
      },

      handlerUp () {
        // console.log(this.tableSelectIdList.length)
        if (this.tableSelectIdList.length > 0) {
          if (confirm(`确定要批量启用这些职位 `)) {
            changeJob({'id_list': this.tableSelectIdList}, 'delete').then(
              res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  if (this.searchVal) {
                    this.getjoblist(this.searchVal)
                  } else {
                    this.getjoblist()
                  }
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
          }
        } else {
          this.$Message.info(`你总要选中点什么吧`)
        }
      },
      handlerDelete () {
        // console.log(this.tableSelectIdList.length)
        if (this.tableSelectIdList.length > 0) {
          if (confirm(`确定要批量删除选中职位 `)) {
            operationjob({'id_list': this.tableSelectIdList}, 'delete').then(
              res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  if (this.searchVal) {
                    this.getjoblist(this.searchVal)
                  } else {
                    this.getjoblist()
                  }
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
          }
        } else {
          this.$Message.info(`你总要选中点什么吧`)
        }
      },
      // 删除
      delData (params) {
        if (confirm(`确定要删除 ${params.row.Jobname}`)) {
          // console.log(params.row.id)
          operationjob(
            {
              'id': params.row.Id
            },
            'delete'
          ).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.tableData_job.splice(params.index, 1)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }
      },
      getsalarytype(stype) {
        if (stype == 1){
          return '元/月'
        }else if(stype == 2){
          return '元/日'
        }else if(stype == 2){
          return '元/月'
        }else if(stype == 3){
          return '元/小时'
        }else if(stype == 4){
          return '元/年'
        }else if(stype == 5){
          return '元/件'
          }else{
          return ''
        }
      },
       editModal (paramsRow, meth, mtitle) {
        this.modalMap.modalVisible = true
        this.modalMap.modalTitle = mtitle
        this.editModalData = meth
        this.getjobspapamsList()
        this.getjobstypeList()
        var day2 = new Date()
        day2.setTime(day2.getTime())
        var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
         this.formValidate_job.Jstime = s2
         this.formValidate_job.Jetime = s2
        if (paramsRow && paramsRow.Id) {
          this.formValidate_job = {
            bcid: paramsRow.broker_company,
            Id: paramsRow.Id,
            Jobname: paramsRow.Jobname,
            Jabbreviation: paramsRow.Jabbreviation,
            Jdescribe: paramsRow.Jdescribe,
            Jnum: paramsRow.Jnum,
            Jexperience: paramsRow.Jexperience,
            Jeducation: paramsRow.Jeducation,
            Jsalary_type: paramsRow.Jsalary_type,
            Jsalary_number_type: paramsRow.Jsalary_number_type,
            Jsalary_number: paramsRow.Jsalary_number,
            Jsalary_number_end: paramsRow.Jsalary_number_end,
            Jsex: paramsRow.Jsex,
            Jage_s: paramsRow.Jage_s,
            Jage_e: paramsRow.Jage_e,
            Jrequirement: paramsRow.Jrequirement,
            Jaddress: paramsRow.Jaddress,
            Jstate: paramsRow.Jstate,
            Jstime: paramsRow.Jstime,
            Jetime: paramsRow.Jetime,
            Jtype: paramsRow.Jtype,
            Jlinkman: paramsRow.Jlinkman,
            Jphone: paramsRow.Jphone,
            Jmarriage: paramsRow.Jmarriage,
            Juid: paramsRow.Juid,
            Jcid: paramsRow.Jcid,
            Jsuit: paramsRow.Jsuit
          }

          if (paramsRow.Jsalary_number_type == 1){
            this.formValidate_job.Jsalary_number_type = true
          }else{
            this.formValidate_job.Jsalary_number_type = false
          }
          setTimeout(() => {
            getCompanylist(1, 20, '', paramsRow.Jcid).then(res => {
              if (res.data.code === 0) {
                this.companyoptions = res.data.data
              }
            })
          }, 200)
        } else {
          this.formValidate_job = {
            Id: 0,
            Jobname: '',
            Jabbreviation: '',
            Jdescribe: '',
            Jnum: '',
            Jsalary_type: 1,
            Jsalary_number_type:false,
            Jsalary_number: 5000,
            Jsalary_number_end: 6000,
            Jexperience: '1',
            Jeducation: '1',
            Jage_s: 18,
            Jage_e: 28,
            Jsex: '1',
            Jrequirement: '',
            Jaddress: '',
            Jstime: s2,
            Jetime: s2,
            Jtype: '1',
            Jlinkman: '',
            Jphone: '',
            Jmarriage: '1',
            Juid: '',
            Jcid: '',
            Jsuit: []
          }
        }
      }
    },

    watch: {
      searchVal (val) {
        this.searchVal = val
        // this.getServerList(this.searchVal)
      }
    },
    mounted () {
      this.getjoblist()
    }
  }

</script>

<style lang="less" scoped>
  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
